import { render, staticRenderFns } from "./ModalAddMemberPermission.vue?vue&type=template&id=341fb5ce&scoped=true&"
import script from "./ModalAddMemberPermission.vue?vue&type=script&lang=js&"
export * from "./ModalAddMemberPermission.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddMemberPermission.vue?vue&type=style&index=0&id=341fb5ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341fb5ce",
  null
  
)

export default component.exports